/**
 * mosso上报参数
 */
let mossoParams = {

    prefix : '',    // pageType前缀，可选

    path: '',           // 站点路径，可选

    osact: 0,

    virtualDomain: '',  // 虚拟上报路径
    
    routerDesc: {},      // pageName配置所需，可选

    siteType: 'os',     

    stayTime: 0,

    repeatApplay: 'true',

    // ingame: 1,
    
    project: 'other'
}

export { mossoParams }